import { render, staticRenderFns } from "./AdminRegisterLayout.vue?vue&type=template&id=a847b128&"
import script from "./AdminRegisterLayout.vue?vue&type=script&lang=ts&"
export * from "./AdminRegisterLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports